class UserDataService {
  /** Guarda información asociada al usuario logueado */
  set = (key: string, value: any) => new Promise<any>((resolve: (value?: any | PromiseLike<any> | undefined) => void, reject: (reason?: any) => void) => {
    
    // Por el momento se guarda en una cookie
    const duraciondias = 30 * 24 * 60 * 60 * 1000; // 30 días
    const expire = new Date();
    expire.setTime(expire.getTime() + duraciondias);

    document.cookie = `TSV_UserConfig_${key}=${value ? JSON.stringify(value) : ''};Path=/;expires=${expire.toUTCString()};`
    
    return resolve(true);
  });

  /** Devuelve informacion asociada al usuario logueado */
  get = (key: string) : Promise<any> => new Promise<any>((resolve: (value?: any | PromiseLike<any> | undefined) => void, reject: (reason?: any) => void) => {

    // Por el momento se guarda como cookie
    const name = `TSV_UserConfig_${key}=`;
    const cookies = decodeURIComponent(document.cookie).split(';');
    const cookie = cookies.find(co => co.trim().indexOf(name) === 0);
    if (!cookie || cookie === '') return resolve(undefined);

    const value = cookie.trim().substring(name.length, cookie.length);

    return resolve(value ? JSON.parse(value) : undefined);
  });
}

const UserData = new UserDataService();
export default UserData;